import { render, staticRenderFns } from "./tovalidate.vue?vue&type=template&id=7fb00480&scoped=true&"
import script from "./tovalidate.vue?vue&type=script&lang=js&"
export * from "./tovalidate.vue?vue&type=script&lang=js&"
import style0 from "./tovalidate.vue?vue&type=style&index=0&id=7fb00480&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7fb00480",
  null
  
)

export default component.exports